(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-careers-section]');
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('#CareersApplication');
    if (!form || form.querySelector('[data-success-panel]')) return;
    const area = form.querySelector('[data-area-select]');
    const otherGroup = form.querySelector('[data-other-area]');
    const otherInput = otherGroup.querySelector('input');
    const deliveryGroup = form.querySelector('[data-delivery-question]');
    const deliverySelect = deliveryGroup.querySelector('select');
    const firstName = form.querySelector('[data-first-name]');
    const lastName = form.querySelector('[data-last-name]');
    const subject = form.querySelector('[data-application-subject]');
    const submissionDate = form.querySelector('[data-submission-date]');
    const errorSummary = form.querySelector('[data-error-summary]');
    const errorList = form.querySelector('[data-error-list]');
    const submit = form.querySelector('[data-submit]');
    const status = form.querySelector('[data-submit-status]');

    const updateConditionalFields = () => {
      const isOther = area.value === 'Other';
      const isDelivery = area.value === 'Delivery';
      otherGroup.hidden = !isOther;
      otherInput.disabled = !isOther;
      otherInput.required = isOther;
      deliveryGroup.hidden = !isDelivery;
      deliverySelect.disabled = !isDelivery;
      deliverySelect.required = isDelivery;
    };

    const updateSubject = () => {
      const name = `${firstName.value.trim()} ${lastName.value.trim()}`.trim();
      if (!name || !area.value) {
        subject.value = section.dataset.subjectPrefix;
        return;
      }
      subject.value = `${section.dataset.subjectPrefix}: ${name} | ${area.value}`;
    };

    area.addEventListener('change', () => {
      updateConditionalFields();
      updateSubject();
    });
    firstName.addEventListener('input', updateSubject);
    lastName.addEventListener('input', updateSubject);
    updateConditionalFields();
    updateSubject();
    submissionDate.value = new Date().toISOString();

    form.addEventListener('input', (event) => event.target.removeAttribute('aria-invalid'));
    form.addEventListener('submit', (event) => {
      const invalidFields = Array.from(form.querySelectorAll(':invalid')).filter((field) => !field.disabled);
      if (invalidFields.length) {
        event.preventDefault();
        errorList.innerHTML = '';
        invalidFields.forEach((field) => {
          field.setAttribute('aria-invalid', 'true');
          const label = form.querySelector(`label[for="${field.id}"]`);
          const item = document.createElement('li');
          item.textContent = `${label ? label.textContent.trim() : section.dataset.requiredLabel}: ${field.validationMessage}`;
          errorList.appendChild(item);
        });
        errorSummary.hidden = false;
        errorSummary.focus();
        invalidFields[0].focus();
        return;
      }
      updateSubject();
      submissionDate.value = new Date().toISOString();
      submit.disabled = true;
      submit.textContent = submit.dataset.submittingLabel;
      status.textContent = submit.dataset.submittingLabel;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wees-business-account-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hub = document.querySelector('[data-business-hub]');
    if (!hub || hub.dataset.initialized === 'true') return;
    hub.dataset.initialized = 'true';
    const locationInput = hub.querySelector('#wba-location');
    const checkButton = hub.querySelector('[data-check-location]');
    const result = hub.querySelector('[data-checker-result]');
    const deliveryResult = hub.querySelector('[data-delivery-result]');
    const deliveryZip = hub.querySelector('[data-delivery-zip]');
    const deliveryDistance = hub.querySelector('[data-delivery-distance]');
    const deliveryQualification = hub.querySelector('[data-delivery-qualification]');
    const resultHeading = result.querySelector('[data-result-heading]');
    const resultMessage = result.querySelector('[data-result-message]');
    const resultMeta = result.querySelector('[data-result-meta]');
    const resultZip = result.querySelector('[data-result-zip]');
    const resultDistance = result.querySelector('[data-result-distance]');
    const resultQualification = result.querySelector('[data-result-qualification]');
    const resultIcon = result.querySelector('[data-result-icon]');
    const resultAction = result.querySelector('[data-result-action]');
    const origin = [42.35111270006, -83.182330106439];
    let zipDataPromise;
    const radians = (degrees) => degrees * Math.PI / 180;
    const distanceMiles = (latitude, longitude) => {
      const latitudeDelta = radians(latitude - origin[0]);
      const longitudeDelta = radians(longitude - origin[1]);
      const a = Math.sin(latitudeDelta / 2) ** 2 + Math.cos(radians(origin[0])) * Math.cos(radians(latitude)) * Math.sin(longitudeDelta / 2) ** 2;
      return 3958.7613 * 2 * Math.asin(Math.sqrt(a));
    };
    const loadZipData = () => {
      if (!zipDataPromise) zipDataPromise = fetch(hub.dataset.zipAsset, {credentials:'same-origin'}).then((response) => {
        if (!response.ok) throw new Error('ZIP lookup unavailable');
        return response.json();
      });
      return zipDataPromise;
    };
    const showZipResult = ({title, copy, state, icon, action, zip, miles}) => {
      const hasDistance = zip && Number.isFinite(miles);
      result.className = `wba-result wba-result--${state}`;
      resultHeading.textContent = title;
      resultMessage.textContent = copy;
      resultIcon.textContent = icon;
      resultAction.textContent = action;
      resultMeta.hidden = !zip;
      resultZip.textContent = zip || '';
      resultDistance.parentElement.hidden = !hasDistance;
      resultDistance.textContent = hasDistance ? `${miles.toFixed(1)} miles` : '';
      resultQualification.hidden = !hasDistance;
      deliveryResult.value = title;
      deliveryZip.value = zip || '';
      deliveryDistance.value = hasDistance ? `${miles.toFixed(1)} miles` : '';
      deliveryQualification.value = 'Exact-address and operational confirmation required';
      resultHeading.focus({preventScroll:true});
    };
    const checkZip = async () => {
      const zip = locationInput.value.trim();
      checkButton.disabled = true;
      checkButton.textContent = 'Checking…';
      try {
        if (!/^\d{5}$/.test(zip)) throw new Error('invalid');
        const data = await loadZipData();
        const centroid = data.zips[zip];
        if (!centroid) throw new Error('missing');
        const miles = distanceMiles(centroid[0], centroid[1]);
        if (miles <= 38.99) showZipResult({title:'Local Delivery Likely Available',copy:'This ZIP code appears to fall within the Wees Express local delivery area.',state:'eligible',icon:'✓',action:'Continue Your Business Account Application',zip,miles});
        else if (miles <= 41) showZipResult({title:'Manual Review Required',copy:'This ZIP code is near the edge of the Wees Express local delivery area. Submit the business account application and the team will confirm availability for the exact address.',state:'review',icon:'!',action:'Continue Your Business Account Application',zip,miles});
        else showZipResult({title:'Nationwide Business Account Available',copy:'This ZIP code appears to be outside the current local delivery area. Your business can still open a Wees Express account and order eligible products for nationwide shipping.',state:'nationwide',icon:'i',action:'Continue Your Business Account Application',zip,miles});
      } catch (error) {
        showZipResult({title:'ZIP Code Could Not Be Verified',copy:'Enter a valid five-digit ZIP code or continue with the application and the Wees Express team will review your location.',state:'invalid',icon:'!',action:'Continue to Application',zip:/^\d{5}$/.test(zip) ? zip : ''});
      } finally {
        checkButton.disabled = false;
        checkButton.textContent = 'Check ZIP Code';
      }
    };
    checkButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkZip();
    }, true);
    locationInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkZip();
      }
    });
    const form = hub.querySelector('#BusinessAccountRequest');
    if (!form) return;
    const successPanel = form.querySelector('[data-success-panel]');
    if (successPanel) {
      successPanel.focus();
      return;
    }
    const taxSelect = form.querySelector('[data-tax-select]');
    const taxPanel = form.querySelector('[data-tax-panel]');
    const taxFields = Array.from(taxPanel.querySelectorAll('input'));
    const taxRequired = Array.from(taxPanel.querySelectorAll('[data-tax-required]'));
    const ein = form.querySelector('[data-ein]');
    const noEin = form.querySelector('[data-no-ein]');
    const businessName = form.querySelector('[data-business-name]');
    const subject = form.querySelector('[data-request-subject]');
    const executiveReport = form.querySelector('[data-executive-report]');
    const errorSummary = form.querySelector('[data-form-error]');
    const errorList = form.querySelector('[data-error-list]');
    const submit = form.querySelector('[data-submit]');
    const submitStatus = form.querySelector('[data-submit-status]');
    const updateTaxFields = () => {
      const requested = taxSelect.value === 'Yes';
      taxPanel.hidden = !requested;
      taxFields.forEach((field) => { field.disabled = !requested; });
      taxRequired.forEach((field) => { field.required = requested; });
    };
    const updateEin = () => {
      if (noEin.checked) ein.value = '';
      ein.disabled = noEin.checked;
    };
    const updateSubject = () => {
      const name = businessName.value.trim();
      subject.value = name ? `New Wees Express Business Account Request — ${name}` : 'New Wees Express Business Account Request';
    };
    taxSelect.addEventListener('change', updateTaxFields);
    noEin.addEventListener('change', updateEin);
    businessName.addEventListener('input', updateSubject);
    form.addEventListener('input', (event) => event.target.removeAttribute('aria-invalid'));
    updateTaxFields();
    updateEin();
    updateSubject();
    const fieldValue = (selector) => form.querySelector(selector)?.value.trim() || '';
    const selectedProducts = () => Array.from(form.querySelectorAll('.wba-choices input:checked')).map((field) => field.nextElementSibling.textContent.trim());
    const reportSection = (title, rows) => {
      const populated = rows.filter((row) => row[1]);
      if (!populated.length) return '';
      return `${title}\n${'-'.repeat(title.length)}\n${populated.map((row) => `${row[0]}: ${row[1]}`).join('\n')}`;
    };
    const buildExecutiveReport = () => {
      const easternDate = new Intl.DateTimeFormat('en-US', {timeZone:'America/Detroit',dateStyle:'long',timeStyle:'short'}).format(new Date());
      const products = selectedProducts();
      const sections = [
        '================================================\nBUSINESS ACCOUNT REQUEST\n================================================',
        reportSection('Submission Summary', [['Submitted', easternDate],['Source', fieldValue('input[name="contact[Submission source]"]')],['Preliminary delivery result', deliveryResult?.value || 'Not checked'],['ZIP code', deliveryZip?.value],['Approximate ZIP-centroid distance', deliveryDistance?.value],['Qualification', deliveryQualification?.value]]),
        reportSection('Business Information', [['Legal business name', fieldValue('#wba-legal-name')],['DBA name', fieldValue('#wba-dba')],['Business type', fieldValue('#wba-business-type')],['Industry or operation type', fieldValue('#wba-industry')],['Business website', fieldValue('#wba-website')],['Number of locations', fieldValue('#wba-locations')]]),
        reportSection('Primary Contact', [['Name', `${fieldValue('#wba-first')} ${fieldValue('#wba-last')}`.trim()],['Job title or role', fieldValue('#wba-role')],['Business email', fieldValue('#wba-email')],['Business phone', fieldValue('#wba-phone')],['Preferred contact method', fieldValue('#wba-contact-method')]]),
        reportSection('Business Address', [['Street address', fieldValue('#wba-street')],['Address line 2', fieldValue('#wba-address-2')],['City', fieldValue('#wba-city')],['State', fieldValue('#wba-state')],['ZIP or postal code', fieldValue('#wba-zip')],['Country', fieldValue('#wba-country')]]),
        reportSection('Requested Services', [['Services', fieldValue('#wba-path')]]),
        products.length ? `Products of Interest\n--------------------\n${products.map((product) => `• ${product}`).join('\n')}` : '',
        reportSection('Purchasing Profile', [['Estimated purchasing frequency', fieldValue('#wba-frequency')],['Estimated monthly supply-spend range', fieldValue('#wba-spend')],['Multi-location details', fieldValue('#wba-multi-location')]]),
        reportSection('Tax Status', [['EIN status', noEin.checked ? 'I do not have an EIN' : (fieldValue('#wba-ein') ? 'EIN provided' : 'Not provided')],['Tax-exempt request', fieldValue('#wba-tax-request')],['State of exemption', fieldValue('#wba-exemption-state')],['Type of exemption', fieldValue('#wba-exemption-type')],['Certificate or exemption number', fieldValue('#wba-certificate-number')],['Expiration date', fieldValue('#wba-expiration')],['Authorized purchaser name', fieldValue('#wba-authorized-purchaser')]]),
        reportSection('Additional Notes', [['Additional business notes', fieldValue('#wba-challenges')]])
      ].filter(Boolean);
      executiveReport.value = sections.join('\n\n');
    };
    form.addEventListener('submit', (event) => {
      const invalidFields = Array.from(form.querySelectorAll('input:invalid, select:invalid, textarea:invalid')).filter((field) => !field.disabled);
      if (invalidFields.length) {
        event.preventDefault();
        errorList.innerHTML = '';
        invalidFields.forEach((field) => {
          field.setAttribute('aria-invalid', 'true');
          const label = field.id ? form.querySelector(`label[for="${field.id}"]`) : null;
          const item = document.createElement('li');
          item.textContent = `${label ? label.textContent.trim() : 'Required field'}: ${field.validationMessage}`;
          errorList.appendChild(item);
        });
        errorSummary.hidden = false;
        errorSummary.focus();
        invalidFields[0].focus();
        return;
      }
      updateSubject();
      buildExecutiveReport();
      Array.from(form.querySelectorAll('[name^="contact["]')).forEach((field) => {
        if (field === executiveReport || field === subject || field.id === 'wba-email') return;
        field.removeAttribute('name');
      });
      submit.disabled = true;
      submit.textContent = submit.dataset.submittingLabel;
      submitStatus.textContent = submit.dataset.submittingLabel;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
